var _path, _path2, _path3, _path4, _path5, _path6, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 158,
    height: 43,
    viewBox: "0 0 158 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.839844 14.25L0 8.11001H11.45C21.12 8.11001 25.1699 11.8 25.1699 17.05C25.1699 20.12 23.17 22.51 20.23 24.05C24.55 25.2 26.73 27.54 26.73 30.71C26.73 36.79 21.73 41.84 10.73 41.84H0.799805L0.839844 14.25ZM7.69995 14.25V21.94H13.01C16.01 21.94 18.26 19.94 18.26 17.78C18.26 15.62 16.44 14.25 11.45 14.25H7.69995ZM7.69995 27.4V35.67H10.77C17.37 35.67 19.8198 33.67 19.8198 31.09C19.8198 28.7 17.53 27.4 13.01 27.4H7.69995Z",
    fill: "#EC1A1A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M41.0799 34.53H33.3799V41.81H41.0799V34.53Z",
    fill: "#EC1A1A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M68.0499 0H60.3499V7.28H68.0499V0Z",
    fill: "#EC1A1A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M34.9399 1.13L41.8099 0L40.7699 27.93H33.8999L34.9399 1.13Z",
    fill: "#EC1A1A"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M49.3499 8.11H56.2099V31.67L56.1599 31.82L71.5499 8.11L79.0399 7.44V41.81H72.1799V18.1L56.8399 41.81H49.3499V8.11Z",
    fill: "#EC1A1A"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M88.3999 8.1H95.27V21.15H110.04V8.1L116.9 7.42001V41.8H110.04V27.24H95.27V41.8H88.3999V8.1Z",
    fill: "#EC1A1A"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M147.94 34.16H133.59L129.69 42.53L123.19 40.77L138.79 8.11001H146.38L157.88 41.81H150.54L147.94 34.16ZM136.4 28.08H145.86L141.86 16.27L136.4 28.08Z",
    fill: "#EC1A1A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.bf0e6cf8a5547bc7f635983ad0b93aa7.svg";
export { ForwardRef as ReactComponent };